/**
 * Design-system units (1 unit = 0.25rem), so 320 caps the board at 1280px. Below that
 * width nothing changes — the cap only affects wide monitors, where a full-bleed
 * five-column table becomes hard to scan.
 */
export const SALES_LEAGUE_CONTENT_MAX_WIDTH = 320;
